import React, { useState } from "react";
import { useMutation, gql } from "@apollo/client";

const CREATE_ALBUM = gql`
  mutation CreateAlbum($input: CreateAlbumInput!) {
    createAlbum(input: $input) {
      id
      title
      releaseDate
      isPurchasable
      price
    }
  }
`;

const CreateAlbumForm = ({ artistPageId, refetch }) => {
  const [formData, setFormData] = useState({
    title: "",
    releaseDate: "",
    coverImage: "",
    isPurchasable: false,
    price: "",
  });

  const token = sessionStorage.getItem("token");

  const [createAlbum, { loading }] = useMutation(CREATE_ALBUM, {
    context: { headers: { Authorization: `Bearer ${token}` } },
    onCompleted: () => {
      refetch?.();
      setFormData({ title: "", releaseDate: "", coverImage: "", isPurchasable: false, price: "" });
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const variables = {
      ...formData,
      artistPageId,
      price: formData.isPurchasable ? parseFloat(formData.price || "0") : null,
    };

    createAlbum({ variables: { input: variables } });
  };

  return (
    <form onSubmit={handleSubmit} className="form-section">
      <h3>Create Album</h3>

      <input
        type="text"
        placeholder="Album Title"
        value={formData.title}
        onChange={(e) => setFormData({ ...formData, title: e.target.value })}
      />

      <input
        type="date"
        value={formData.releaseDate}
        onChange={(e) => setFormData({ ...formData, releaseDate: e.target.value })}
      />

      <input
        type="text"
        placeholder="Cover Image URL"
        value={formData.coverImage}
        onChange={(e) => setFormData({ ...formData, coverImage: e.target.value })}
      />

      <label>
        <input
          type="checkbox"
          checked={formData.isPurchasable}
          onChange={(e) => setFormData({ ...formData, isPurchasable: e.target.checked })}
        />
        Purchasable
      </label>

      {formData.isPurchasable && (
        <input
          type="number"
          step="0.01"
          placeholder="Price"
          value={formData.price}
          onChange={(e) => setFormData({ ...formData, price: e.target.value })}
        />
      )}

      <button type="submit" disabled={loading}>
        {loading ? "Creating..." : "Create Album"}
      </button>
    </form>
  );
};

export default CreateAlbumForm;
